module.exports = {
          srcSet: __webpack_public_path__ + "b5ba846c0dcaf0523e4ab447e59f1db1-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "b5ba846c0dcaf0523e4ab447e59f1db1-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "b5ba846c0dcaf0523e4ab447e59f1db1-120.png",
          toString:function(){return __webpack_public_path__ + "b5ba846c0dcaf0523e4ab447e59f1db1-120.png"},
          
          width: 120,
          height: 120
        }